import React, {useState} from "react";

import {Modal, Button, Table} from "react-bootstrap";
import {Envelope} from "react-bootstrap-icons";
import moment from "moment";

import MailViewer from "../MailViewer";
import {renderStatus} from "../../_helpers/components";

const HistoryViewer = (props) => {

  const [selectedMail, setSelectedMail] = useState("");
  const [showMailViewer, setShowMailViewer] = useState(false);

  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg" backdrop={showMailViewer ? "static" : true}>
        <Modal.Header closeButton>
          <Modal.Title>Mail Viewer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table size="sm">
            <tbody>
            {props.history?.map((h, index) => (
              <tr key={index}>
                <td>{moment(h.mailReceivedTime).format("DD.MM.YYYY HH:mm:ss")}</td>
                <td>{h.jobName}</td>
                <td>{renderStatus(h.status)}</td>
                <td><Button variant="link" size="sm" onClick={() => {
                  setSelectedMail(h.mailId);
                  setShowMailViewer(true)
                }}><Envelope/></Button></td>
              </tr>
            ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <MailViewer show={showMailViewer} handleClose={() => setShowMailViewer(false)} mailId={selectedMail}/>
    </>
  );
}

export default HistoryViewer;